var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-flow"},_vm._l((_vm.resolvedSteps),function(step){return _c('profile-company-flow-step',{key:step.key,attrs:{"step":step},on:{"open-document":_vm.openDocument,"archive-document":function($event){return _vm.$emit('archive-sequence', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }